export const isSupportApplePay = (isParamsSupport) => {
  const isBrowser = () => typeof window !== 'undefined';
  try {
    return !!isParamsSupport && isBrowser() && window.ApplePaySession && window.ApplePaySession.canMakePayments();
  } catch (e) {
    return false;
  }
};

export const createPaymentRequest = (paymentMethodData, shoppingCartDetails, paymentOptions) => {
  return new PaymentRequest(paymentMethodData, shoppingCartDetails, paymentOptions);
};

export const abortPaymentRequest = (paymentRequest) => {
  if (paymentRequest) {
    paymentRequest.abort();
  }
};
